import * as React from "react";
import { Provider as PaperProvider, DefaultTheme } from "react-native-paper";
import {
  whiteColor,
  blackColor,
  descriptionColor,
  dividerColor,
} from "../colors";
import { StyleSheet, View, ScrollView, ImageBackground } from "react-native";
import { IconButton } from "react-native-paper";
import IconIonicons from "react-native-vector-icons/Ionicons";
import resultBackground from "../../containers/Images/resultBackground.png";
import Background from "../Background";
import Icon from "react-native-vector-icons/AntDesign";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import routes from "../../routing/routes";
import isWEB from "../isWEB";
import MAX_WIDTH from "../MaxWidth";

const theme = {
  ...DefaultTheme,
  roundness: 0,
  colors: {
    ...DefaultTheme.colors,
    primary: blackColor,
    background: whiteColor,
  },
};

export default (props) => {
  const insets = useSafeAreaInsets();

  const back = () => props.navigation.navigate(props.backRoute);
  const backSettings = () => props.navigation.navigate(routes.Home);
  return (
    <PaperProvider theme={theme}>
      <View style={styles.wrapper}>
        <View
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            paddingTop: insets.top,
            backgroundColor: whiteColor,
            top: 0,
          }}
        >
          <View
            style={{
              maxWidth: MAX_WIDTH.SETTINGS,
              alignSelf: "center",
              width: "100%",
              justifyContent: "space-between",
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "flex-start",
            }}
          >
            {props.isBackIcon ? (
              <IconButton
                icon={() => (
                  <Icon name="left" size={24} color={blackColor}></Icon>
                )}
                size={20}
                onPress={back}
              />
            ) : (
              <View />
            )}
            {props.isSettingsIcon && (
              <IconButton
                icon={() => (
                  <IconIonicons
                    name="md-settings-outline"
                    size={24}
                    color={blackColor}
                  ></IconIonicons>
                )}
                size={20}
                onPress={props.onClickGoToSettings}
              />
            )}
            {props.isSettingsIconSelected && (
              <IconButton
                icon={() => (
                  <IconIonicons
                    name="md-settings-sharp"
                    size={24}
                    color={blackColor}
                    onPress={backSettings}
                  ></IconIonicons>
                )}
                size={20}
              />
            )}
            {props.isCloseIcon && (
              <IconButton
                icon={() => (
                  <IconIonicons
                    name="close-outline"
                    size={30}
                    color={blackColor}
                    onPress={back}
                  ></IconIonicons>
                )}
                size={20}
              />
            )}
          </View>
        </View>
        <ScrollView style={styles.scrollView}>
          <View style={styles.container}>
            <View style={styles.contentContainer}>
              {props.isResult ? (
                <ImageBackground
                  source={props.noBackground ? null : resultBackground}
                  style={styles.screenBackground}
                >
                  {props.children}
                </ImageBackground>
              ) : (
                <Background
                  noBackground={props.noBackground}
                  maxWidth={props.maxWidth}
                >
                  {props.children}
                </Background>
              )}
            </View>
          </View>
        </ScrollView>
      </View>
    </PaperProvider>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
    width: "100%",
    backgroundColor: whiteColor,
  },
  text: {
    color: blackColor,
  },
  textTitle: {
    fontSize: 16,
    lineHeight: 16,
    letterSpacing: 0.25,
    color: blackColor,
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  textSubtitle: {
    fontSize: 12,
    lineHeight: 24,
    letterSpacing: 0.15,
    textTransform: "uppercase",
    color: blackColor,
  },
  textdescriptionDesign: {
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.25,
    color: descriptionColor,
  },
  titleContainer: {
    alignItems: "center",
  },
  title: {
    fontSize: 16,
    lineHeight: 26,
    letterSpacing: 1.25,
    paddingLeft: 0,
    paddingTop: 50,
    color: blackColor,
    textTransform: "uppercase",
  },
  subtitle: {
    fontSize: 20,
    lineHeight: 26,
    paddingLeft: 0,
    letterSpacing: 1.25,
    paddingBottom: 50,
    paddingTop: 0,
    color: blackColor,
    textTransform: "uppercase",
    fontWeight: "400",
  },
  titleColor: {
    textAlign: "center",
    fontSize: 16,
    lineHeight: 16,
    letterSpacing: 1.25,
    paddingBottom: 16,
    paddingTop: 10,
    color: blackColor,
  },
  contentContainer: {
    height: "100%",
    alignItems: "center",
    alignContent: "flex-start",
    justifyContent: "flex-start",
    backgroundColor: whiteColor,
  },
  container: {
    width: "100%",
  },
  titleOne: {
    textAlign: "left",
    fontSize: 24,
    lineHeight: 16,
    paddingTop: 20,
    letterSpacing: 0.15,
  },
  divider: {
    width: "100%",
    backgroundColor: dividerColor,
  },
  scrollView: {
    backgroundColor: whiteColor,
    paddingBottom: 30,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
    width: "100%",
  },
  containerButtons: {
    backgroundColor: whiteColor,
    width: 360,
    alignItems: "center",
    alignContent: "flex-start",
    justifyContent: "flex-start",
  },
  screenBackground: {
    width: "100%",
    height: "110%",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
  },
  noBackgroundView: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
});

// flexDirection: 'row',
//     flexWrap: 'wrap',
//     justifyContent: 'space-between',
//     alignItems: 'flex-start',
//     width: 340,

// const styles = StyleSheet.create({
//   wrapper: {
//     alignItems: "center",
//     position: "absolute",
//     top: 0,
//     bottom: 0,
//     left: 0,
//     right: 0,
//     paddingTop: 35,
//     width: "100%",
//     backgroundColor: whiteColor,
//   },
//   title: {
//     textAlign: "center",
//     fontSize: 24,
//     lineHeight: 16,
//     letterSpacing: 1.25,
//     paddingBottom: 24,
//     paddingTop: 10,
//   },
//   questionsDesign: {
//     alignItems: "center",
//     justifyContent: "center",
//   },
//   testRadio: {
//     padding: 0,
//   },
//   scrollView: {
//     backgroundColor: whiteColor,
//     paddingBottom: 30,
//     top: 0,
//     bottom: 0,
//     left: 0,
//     right: 0,
//     paddingTop: 0,
//     width: "100%",
//   },
//   container: {
//     height: "100%",
//     alignItems: "center",
//     alignContent: "flex-start",
//     justifyContent: "flex-start",
//     backgroundColor: whiteColor,
//   },
// });
